import { render, staticRenderFns } from "./ColorContrastMixin.js.vue?vue&type=template&id=3d0e5e8f&scoped=true&"
import script from "./ColorContrastMixin.js.vue?vue&type=script&lang=js&"
export * from "./ColorContrastMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e5e8f",
  null
  
)

export default component.exports